import React from 'react';
import ReactPaginate from 'react-paginate';
import { observer } from 'mobx-react';

function BaasicPagerTemplate({ queryUtility, ...otherProps }) {
	const page = queryUtility.filter.pageNumber;
	return (
		<ReactPaginate
			previousLabel={<i className="fa fa-angle-left"></i>}
			nextLabel={<i className="fa fa-angle-right"></i>}
			breakLabel={<span>&hellip;</span>}
			breakClassName={'break-me'}
			pageCount={queryUtility.totalPages}
			marginPagesDisplayed={2}
			pageRangeDisplayed={5}
			forcePage={page - 1}
			onPageChange={data => queryUtility.changePage(data.selected + 1)}
			containerClassName={'pagination--primary'}
			subContainerClassName={'pages pagination'}
			activeClassName={'active'}
		/>
	);
}

export default observer(BaasicPagerTemplate);
